<template>
  <d-page :title="title">
    <p slot="customIcon" class="clear" @click="clearChange">清空</p>
    <d-custom-van-tab :list="tabList" @click="onClick" />
    <div class="container">
      <p class="tip">温馨提示：仅展示近7天的历史足迹信息；</p>

      <!-- 资讯  -->
      <d-list-page ref="list" :api="apis[0]" :params="params" isActivated v-if="active === 0">
        <template #item="{ item }">
          <consult-item :data="item" />
        </template>
      </d-list-page>

      <!-- 智库  -->
      <d-list-page ref="list" :api="apis[1]" :params="params" isActivated v-if="active === 1">
        <template #item="{ item }">
          <library-item :data="item" />
        </template>
      </d-list-page>

      <!-- 律师  -->
      <d-list-page ref="list" :api="apis[2]" :params="params" isActivated v-if="active === 2">
        <template #item="{ item }">
          <lawyer-item :data="item" />
        </template>
      </d-list-page>
    </div>
  </d-page>
</template>

<script>
  import consultItem from './components/consultItem'
  import libraryItem from './components/libraryItem'
  import lawyerItem from './components/lawyerItem'
  import DCustomVanTab from '../../components/d-custom-van-tab/index'
  import DListPage from '../../components/d-list-page/index'
  import DFooter from '../../components/d-footer/index'

  import {
    apiUserActionUserFootprintClear,
    apiUserActionUserFootprintCount,
    apiArticleArticleFootArticleId,
    apiSpecialistTalentPoolFootList,
    apiSpecialistLawyerFootLawyerList
  } from '@/generated_api/resource'

  export default {
    name: 'my-footprint',
    components: { DFooter, DListPage, DCustomVanTab, consultItem, libraryItem, lawyerItem },
    data() {
      return {
        active: 0,
        title: '',
        api: apiArticleArticleFootArticleId,
        params: {
          objectType: '0'
        },
        tabList: [
          {
            title: '资讯',
            id: 0
          },
          {
            title: '智库',
            id: 1
          },
          {
            title: '律师',
            id: 2
          }
        ],
        checked: false,
        clear: false,
        apis: [apiArticleArticleFootArticleId, apiSpecialistTalentPoolFootList, apiSpecialistLawyerFootLawyerList]
      }
    },
    created() {
      this.getFootprintCount()
    },
    methods: {
      // checkHanle() {
      //     this.checked = !this.checked;
      // },
      clearChange() {
        this.clearFootList()
      },
      // 切换 tab
      onClick(val) {
        this.active = val
        this.params.objectType = val
        this.$nextTick(() => {
          this.$refs.list.refresh()
        })
      },
      // 清空对应tab下足迹列表数据
      clearFootList() {
        apiUserActionUserFootprintClear({
          actionType: this.params.objectType
        }).then(data => {
          // console.log(data)
          this.$refs.list.refresh()
          this.getFootprintCount()
        })
      },
      getFootprintCount() {
        apiUserActionUserFootprintCount().then(data => {
          let number = 0
          if (data > 0) {
            number = data
          } else {
            number = 0
          }
          this.$nextTick(() => {
            this.title = '我的足迹(' + number + ')'
          })
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .container {
    padding: 12px;

    .tip {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #165ebf;
      line-height: 17px;
    }
  }

  .footer {
    width: 375px;
    height: 68px;
    padding: 12px 24px;
    background: #ffffff;
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.06), 0px -2px 5px 0px rgba(0, 0, 0, 0.04);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .choose {
      &-record {
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 16px;
        color: #cccccc;
        letter-spacing: 2px;

        .number {
          color: #165ebf;
        }
      }

      &-btn {
        margin-top: 6px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
      }
    }

    p {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 20px;

      .checked {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
    }

    .confirm {
      width: 110px;
      height: 40px;
      border-radius: 22px;
      border: 1px solid #165ebf;
      box-sizing: border-box;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #165ebf;
      line-height: 40px;
      background: #ffffff;
    }
  }

  .clear {
    font-size: 17px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #165ebf;
    line-height: 24px;
  }
</style>
